import * as NUMBER from 'constant/number'
import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Form, Modal } from 'antd'
import FormModal from 'view/component/form-modal'
import { addPermittedGroup } from 'action/site'
import PermittedGroupForm from 'view/page/site-management/component/permitted-group-form'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'New permitted group added'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'An Error has occured'
})

const NewPermittedGroup = ({ siteUuid, addPermittedGroup, submitting }) => {
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()

  const handleClick = () => setVisible(true)

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      const response = await addPermittedGroup(siteUuid, values)
      setVisible(false)
      form.resetFields()
      !response.error ? success(buildSuccessObject(response)) : error(buildErrorObject(response))
    }).catch(({ errorFields }) => form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
  }

  return (
    <>
      <a onClick={handleClick}>New Permitted Group</a>
      <FormModal
        handleSubmit={handleSubmit}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          form.resetFields()
        }}
        title='New Permitted Group'
        visible={visible}
      >
        <PermittedGroupForm
          form={form}
          siteUuid={siteUuid}
        />
      </FormModal>
    </>
  )
}

NewPermittedGroup.propTypes = {
  addPermittedGroup: PropTypes.func,
  siteUuid: PropTypes.string,
  submitting: PropTypes.bool
}

const mapStateToProps = (state) => ({
  submitting: state.loader.siteSubmitting
})

const mapDispatchToProps = (dispatch) => ({
  addPermittedGroup: bindActionCreators(addPermittedGroup, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(NewPermittedGroup)
